import React from 'react';

const VideoListItem = ( {video, onVideoSelect} ) => {
	const imageUrl = video.snippet.thumbnails.default.url;


	return (
	 	<li className='li-container' onClick={() => onVideoSelect(video)} >
	 		<div>
	 			<div>
	 				<img alt="videothumbnail" src={imageUrl} />
	 			</div>
	 			<div>
	 				<div>{video.snippet.title}</div>
	 			</div>
	 		</div>
		</li>
	);
}

export default VideoListItem;



// WEBPACK FOOTER //
// ./src/components/video_list_item.js